<div class="mainBorder loading" *ngIf="loading">
    <span class="spinner-border spinner-border-sm"></span>&nbsp;<B>{{message}}</B>

</div>
